export default __webpack_public_path__ + "static/media/defaultA.60f2a475.jpg";